import { render } from "./OrderTable.vue?vue&type=template&id=97df3056&scoped=true"
import script from "./OrderTable.vue?vue&type=script&lang=js"
export * from "./OrderTable.vue?vue&type=script&lang=js"

import "./OrderTable.vue?vue&type=style&index=0&id=97df3056&lang=scss"
import "./OrderTable.vue?vue&type=style&index=1&id=97df3056&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97df3056"]])

export default __exports__